import { Wind, ListChecks, Smartphone } from 'lucide-react';
import { benTaubOr, BB_DOC } from './benTaubOr';

/*
 * Ben Taub Advanced Airway rotation (CA-1). Built from the Blackboard Airway
 * Orientation & Curriculum. See docs/blackboard-ben-taub-subspecialties.md.
 * Contacts, Locations and Documents extend the General OR rotation.
 */

const AIRWAY = BB_DOC('_368807_1');

export const benTaubAirway = {
  accent: benTaubOr.accent,
  icon: Wind,
  tagline: 'Advanced techniques, equipment hunt, the airway app',
  notesKey: 'notes:ben-taub:airway',

  toolSections: [
    { title: 'Clinical tools', tools: [
      { id: 'checklist', title: 'Rotation Checklist', subtitle: 'What to finish by the end of the month', icon: ListChecks, action: 'guide:checklist', featured: true },
    ] },
    { title: 'Logistics', tools: [
      { id: 'app', title: 'Airway App', subtitle: 'Install the PowerApps app', icon: Smartphone, action: 'guide:app' },
    ] },
  ],

  contacts: {
    storageKey: 'ben-taub-airway-favorites',
    groups: [
      { id: 'airway', title: 'Airway rotation', open: true, items: [
        { label: 'Vu Nguyen, MD, rotation director', phone: '7035975483' },
      ] },
      ...benTaubOr.contacts.groups,
    ],
  },

  documents: {
    storageKey: 'ben-taub-airway-pinned-docs',
    groups: [
      { id: 'airway', title: 'Airway', items: [
        { title: 'Airway orientation and curriculum', subtitle: 'Blackboard', url: AIRWAY },
      ] },
      ...benTaubOr.documents.groups,
    ],
  },

  guides: {
    checklist: {
      title: 'Rotation Checklist',
      sections: [
        { title: 'In the app', blocks: [{ type: 'bullets', items: [
          'Equipment scavenger hunt: find every device on the list and tick it off. First half of the month. You will know where things live when no tech is around',
          'Technique checklist: try each technique, save progress as you go',
          'Case discussions: work through each scenario with your attending in the room. The same case with different attendings shows different approaches',
          'Pre-rotation survey at the start, post-rotation survey at the end',
        ] }] },
        { title: 'Each day', blocks: [{ type: 'bullets', items: [
          'Pick techniques from the app’s list and videos to practise on that day’s cases',
        ] }] },
      ],
      sources: [{ title: 'Airway orientation and curriculum', href: AIRWAY, detail: 'Blackboard, sign-in required' }],
    },

    app: {
      title: 'Airway App',
      sections: [
        { title: 'Install', blocks: [{ type: 'steps', items: [
          'Download Power Apps from the App Store',
          'Sign in with your BCM username and password, the same as email',
          'All Apps, then Airway Rotation',
          'Edit Shortcut, rename if you like, tap the icon, Add to Home Screen',
        ] }] },
      ],
      sources: [{ title: 'Airway app download', href: AIRWAY, detail: 'Blackboard, sign-in required' }],
    },
  },
};
